module.exports = __webpack_public_path__ + "static/TT1332_TW-MARK-D01-clean-85e8907c976404caef1d3902d4e01d79.png";